import React from 'react';
import PropTypes from 'prop-types';

import {classNames} from '~/src/utilities/helpers/css';

import css from './ToggleButton.module.scss';

class ToggleButton extends React.Component {
    updateToggle = () => {
        this.setState({
            checked: !this.state.checked
        });
        this.props.callback && this.props.callback();
    };

    static defaultProps = {
        checked: false,
        variant: 'toggle'
    };

    constructor(props) {
        super(props);
        this.state = {
            checked: props.checked
        };
    }

    render() {
        const toggleClasses = [classNames(css, 'toggleLabel', this.props.variant, this.props.siteArea)];

        if (this.props.className) {
            toggleClasses.push(this.props.className);
        }

        return (
            <label className={toggleClasses.join(' ')}>
                <input type="checkbox" className={css.toggleInput} defaultChecked={this.state.checked} onChange={this.updateToggle} />
                <span className={css.toggleButton}></span>
                {this.props.label && <span className={css.toggleText}>{this.props.label}</span>}
                {this.props.children}
            </label>
        );
    }
}

if (process.env.NODE_ENV === 'development') {
    ToggleButton.propTypes = {
        checked: PropTypes.bool,
        variant: PropTypes.string,
        label: PropTypes.string,
        callback: PropTypes.func,
        className: PropTypes.string
    };
}

export default ToggleButton;
